/**
 * AR invoice READ endpoints — request schemas + wire types.
 *
 * The AR twin of `apBillsReads.ts`: plain RLS-scoped reads served by the Hono
 * handlers through the per-request user client, so org RLS does the
 * authorization (docs/BACKEND_API.md → "Read endpoints").
 *
 * The wire interfaces are shared by the API handlers (response construction)
 * and the web hooks (`unwrap<T>` targets) so the two sides cannot drift.
 *
 * Nullability below is the DDL's, read off `accounts_receivable` — NOT the
 * view's catalog nullability (a view reports every column nullable). The
 * NOT NULL header columns are id, organization_id, invoice_date, due_date,
 * amount_total, client_name and created_at (the last made NOT NULL by the
 * index migration, 20260821141859, as the keyset cursor's precondition);
 * everything else on the header is nullable — `invoice_number` too since
 * post-on-issue (20261101120000): a draft has none until it is issued.
 */
import { z } from "zod";
// ---------------------------------------------------------------------------
// Query-param schemas
// ---------------------------------------------------------------------------
/** Query params for GET /orgs/:orgId/ar-invoices/index. */
export const arInvoiceIndexQuerySchema = z.object({
    projectId: z.string().uuid().optional(),
    businessId: z.string().uuid().optional(),
    personId: z.string().uuid().optional(),
});
//# sourceMappingURL=arInvoicesReads.js.map